import { useState } from 'react';

import { HandleOnChangeType, TAB_VALUES } from './CODForm.interface';

type DrawerKeys =
  | 'openBackgroundDrawer'
  | 'openTitleDrawer'
  | 'openCustomMessageDrawer'
  | 'openHeaderSectionDrawer'
  | 'openConfirmTitleDrawer'
  | 'openKnownUserDrawer'
  | 'openUnknownUserDrawer'
  | 'openComponentSettingsDrawer';

export const useCODForm = () => {
  const [selectedTab, setSelectedTab] = useState<TAB_VALUES>(TAB_VALUES.COD);
  const [drawerStates, setDrawerStates] = useState({
    openBackgroundDrawer: false,
    openTitleDrawer: false,
    openCustomMessageDrawer: false,
    openHeaderSectionDrawer: false,
    openConfirmTitleDrawer: false,
    openKnownUserDrawer: false,
    openUnknownUserDrawer: false,
    openComponentSettingsDrawer: false,
  });

  const handleTabChange = (
    event: React.SyntheticEvent,
    newValue: TAB_VALUES,
  ) => {
    setSelectedTab(newValue);
  };

  const toggleDrawer = (drawer: DrawerKeys) => {
    setDrawerStates((prevState) => ({
      ...prevState,
      [drawer]: !prevState[drawer],
    }));
  };

  const onBackgroundColorChange = (
    nextValue: string,
    handleOnChange: HandleOnChangeType,
  ) => {
    const backgroundKey = 'codSettings.globalSetting.background';
    const productKey = 'codSettings.codSetting.body.styleConfig.product.color';
    const subProductKey =
      'codSettings.codSetting.body.styleConfig.subProduct.color';
    const paginationKey = 'codSettings.codSetting.header.pagination.color';
    const discountPriceKey =
      'codSettings.codSetting.body.styleConfig.discounts.price.color';
    const textColor = nextValue.includes('#000000') ? 'white' : 'black';

    handleOnChange(
      [
        backgroundKey,
        productKey,
        subProductKey,
        paginationKey,
        discountPriceKey,
      ],
      [nextValue, textColor, textColor, textColor, textColor],
    );
  };

  return {
    selectedTab,
    handleTabChange,
    ...drawerStates,
    onBackgroundColorChange,
    onToggleBackgroundDrawer: () => toggleDrawer('openBackgroundDrawer'),
    onToggleTitleDrawer: () => toggleDrawer('openTitleDrawer'),
    onCustomMessageDrawer: () => toggleDrawer('openCustomMessageDrawer'),
    onHeaderSectionDrawer: () => toggleDrawer('openHeaderSectionDrawer'),
    onToggleConfirmTitleDrawer: () => toggleDrawer('openConfirmTitleDrawer'),
    onToggleKnownUserDrawer: () => toggleDrawer('openKnownUserDrawer'),
    onToggleUnknownUserDrawer: () => toggleDrawer('openUnknownUserDrawer'),
    onComponentSettingsDrawer: () =>
      toggleDrawer('openComponentSettingsDrawer'),
  };
};
